import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'
import { NgArrayPipesModule, NgPipesModule } from 'ngx-pipes'

// Import components
import { ArticleList } from '../../../../components/article-list'
import { HtmlContentPipe } from '../../../../shared/pipes/html-content.pipe'
import { ProcessContentPipe } from '../../../../shared/pipes/process-content.pipe'
import { SharedModule } from '../../../../shared/shared.module'
import { MagazineEditionOverviewComponent } from './magazine-edition-overview/magazine-edition-overview.component'
import { YearFilterDialogComponent } from './year-filter-dialog/year-filter-dialog.component'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    NgArrayPipesModule,
    NgPipesModule,
    HtmlContentPipe,
    ProcessContentPipe,
    ArticleList,
    TranslatePipe,
    MagazineEditionOverviewComponent,
    YearFilterDialogComponent,
  ],
  exports: [MagazineEditionOverviewComponent, YearFilterDialogComponent],
})
export class EditionComponentsModule {}
